import { TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';

import './minimum-quantity-text.scss';

type MinimumQuantityTextProps = Readonly<{
    minimumQuantity: number;
    className?: string;
    testId?: string;
}>;

const MINIMUM_QUANTITY_DISPLAY_THRESHOLD = 2;

export const MinimumQuantityText = ({
    minimumQuantity,
    className,
    testId = 'minimum-qty',
}: MinimumQuantityTextProps) => {
    if (minimumQuantity < MINIMUM_QUANTITY_DISPLAY_THRESHOLD) return null;

    return (
        <TextPassage data-testid={testId} className={cn('minimum-quantity-text', className)}>
            Minimum quantity of {minimumQuantity} required
        </TextPassage>
    );
};
